import { FC } from 'react';
import { useMutation } from '@apollo/client';

import Button from 'components/_core/Button';
import useToast from 'components/ToastProvider/useToast';

import locales from '../../../../locales';
import { SetTaxForecastPeriodUnpaidDocument } from './graphql/setTaxForecastPeriodUnpaid.gql';

interface MarkAsNotPaidButtonProps {
  taxForecastPeriodId: string;
}

const MarkAsNotPaidButton: FC<MarkAsNotPaidButtonProps> = ({
  taxForecastPeriodId,
}) => {
  const { showToast } = useToast();

  const [setTaxForecastPeriodUnpaidMutation, { loading }] = useMutation(
    SetTaxForecastPeriodUnpaidDocument,
  );

  const onClick = () =>
    setTaxForecastPeriodUnpaidMutation({
      onCompleted: () =>
        showToast({
          message: locales.history.markAsNotPaidSuccess,
          type: 'success',
        }),
      onError: () =>
        showToast({ message: locales.errorMessage, type: 'error' }),
      variables: {
        input: { taxForecastPeriodId },
      },
    });

  return (
    <Button
      alignSelf="flex-end"
      icon="cross"
      iconPosition="left"
      isLoading={loading}
      onClick={onClick}
      variant="discreet"
    >
      {locales.taxDetails.ctaNotPaid}
    </Button>
  );
};

export default MarkAsNotPaidButton;
